<app-abstract-dialog [dialogWidth]="'700'">
    <ng-container abstract-header>
        <h3 class="abstract-dialog__header__title">{{ title }}</h3>
    </ng-container>
    <ng-container abstract-content>
        <div class="create-user-dialog__content">
            <p class="user-role-text">{{ message }}</p>
            <app-step-roles
                    [selectedRoles]="selectedRoles"
                    (toggleRoleEvent)="toggleRole($event)">
            </app-step-roles>
        </div>
    </ng-container>
    <ng-container abstract-footer>
        <div class="abstract-dialog__footer__buttons-wrapper">
            <div class="abstract-dialog__footer__buttons-wrapper__btn-box">
                <app-button
                        [cssClasses]="'btn small outlined outlined__gray-07'"
                        (buttonClicked)="onCancel()">
                    {{'GENERAL.CANCEL' | translate}}
                </app-button>
            </div>
            <div class="abstract-dialog__footer__buttons-wrapper__btn-box">
                <app-button
                        [cssClasses]="'btn small solid__blue-07'"
                        [disabled]="disabled()"
                        (buttonClicked)="onSaveRoles()">
                    {{'GENERAL.SAVE' | translate}}
                </app-button>
            </div>
        </div>
    </ng-container>
</app-abstract-dialog>
